import { createFileRoute, Outlet, useLocation, useNavigate } from '@tanstack/react-router';

import { AdminPage } from '@/components/admin/AdminPage';

export const Route = createFileRoute('/admin')({
  component: AdminRoutePage,
});

function AdminRoutePage() {
  const navigate = useNavigate({ from: '/admin' });
  const location = useLocation();

  if (location.pathname !== '/admin' && location.pathname !== '/admin/') {
    return <Outlet />;
  }

  return (
    <AdminPage
      onUserSelect={(userId) => {
        void navigate({ to: '/admin/users/$id', params: { id: userId } });
      }}
      onTenantSelect={(tenantId) => {
        void navigate({ to: '/admin/tenants/$id', params: { id: tenantId } });
      }}
    />
  );
}
